import React from 'react';
import {Outlet} from "react-router-dom";
import Header from "../components/Site/Header/Header";
import Footer from "../components/Site/Footer/Footer";
import {Grid} from "@mui/material";
import GoTop from "../components/Site/goTop/GoTop";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const MainLayout = () => {
    return (
        <>
            <Grid container sx={{minHeight: "100vh", width: "100%", display: "flex", flexDirection: "column"}}>
                <Header/>
                <Grid sx={{flexGrow: 1}}>
                    <Outlet/>
                </Grid>
                <Footer/>
                <GoTop/>
                <ToastContainer/>
            </Grid>
        </>
    );
};

export default MainLayout;